import logo1 from "./../media/img/misc/logowhite.png";
export const logo = logo1;

export const links = [
  { text: "Home", route: "home", active: "home" },

  {
    text: "Story",
    route: "story",
    active: "home",
  },
  {
    text: "Winery",
    route: "winery",
    active: "home",
  },
  {
    text: "Wines",
    route: "wines",
    active: "home",
  },
  {
    text: "Infos & contact",
    route: "contact",
    active: "home",
  },
];
